import React from 'react';
import InvestmentRow from './InvestmentRow';

const InvestmentList = ({ investments, onChange }) => {
  if (!investments || investments.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">◌</div>
        <div className="empty-state-text">No investments yet</div>
      </div>
    );
  }

  const list = investments.slice().reverse();

  return (
    <div>
      {list.map((inv) => (
        <InvestmentRow key={inv.index} inv={inv} index={inv.index} onChange={onChange} />
      ))}
    </div>
  );
};

export default InvestmentList;
